import React from 'react';
import SubscribeForm from 'components/Form/SubscribeForm';
import getButtonStyles from 'components/Core/Button/utils/getButtonStyles';
import HyperLink from 'components/Core/HyperLink';
import HeaderModalForm from '../../HeaderModalForm';
import MobileMenuButton from './MobileMenuButton';
import Button from '@mui/material/Button';

import {
  Container,
  StyledButton,
  InnerContainer,
  EmailCapture,
  EmailCaptureContainer,
} from './styles';

const RightMenu = ({
  contextualCta,
  customPhoneNumber,
  isMobileMenuOpened,
  showAdditionalMenuItems,
  setMobileMenuOpened,
  showMenuItems,
  theme,
}) => {
  const ctaButtonType = contextualCta?.color ? getButtonStyles(contextualCta.color) : 'normal';

  const mobileIconClicked = (e) => {
    setMobileMenuOpened(!isMobileMenuOpened);

    const driftChatBox = document.querySelector('.drift-frame-controller');

    if (driftChatBox) {
      driftChatBox.style.display = !isMobileMenuOpened ? 'none' : 'block';
    }
  };

  return (
    <Container className="mobile-right-menu">
      <InnerContainer>
        {showAdditionalMenuItems?.includes('Phone Number') && (
          <Button className="mobile-header-phone">
            <HyperLink
              data-position="Header - Menu Item CTA"
              className="font-h6"
              ctaPosition="phonenumber"
              href={`tel: ${customPhoneNumber || '(855) 899-0970'}`}
            >
              {customPhoneNumber || '(855) 899-0970'}
            </HyperLink>
          </Button>
        )}
        <div id="Original">
          {contextualCta?.__typename === 'ContentfulCallToAction' ? (
            contextualCta.useModalForm ? (
              <HeaderModalForm
                className={`website-header--button-cta header-cta--${ctaButtonType}`}
                buttonLabel={contextualCta.buttonLabel}
                inlineMarketingForm={contextualCta.modalForm}
                type={contextualCta.color}
              />
            ) : (
              <StyledButton
                to={contextualCta.url}
                type={contextualCta.color}
                className={`website-header--button-cta header-cta--${ctaButtonType}`}
                ctaPosition="navigation"
              >
                {contextualCta.buttonLabel}
              </StyledButton>
            )
          ) : (
            contextualCta?.__typename === 'ContentfulInlineMarketingForm' && (
              <EmailCaptureContainer showHeaderForm>
                <EmailCapture>
                  <SubscribeForm
                    inlineMarketingForm={contextualCta}
                    formType="Email Capture"
                    dataPosition="Header"
                    shadow={false}
                    formClassNames="header-email-capture"
                    label="Get our weekly newsletter"
                  />
                </EmailCapture>
              </EmailCaptureContainer>
            )
          )}
        </div>
        {showMenuItems && (
          <MobileMenuButton
            isMobileMenuOpened={isMobileMenuOpened}
            mobileIconClicked={mobileIconClicked}
          />
        )}
      </InnerContainer>
    </Container>
  );
};

export default RightMenu;
